export const layout = {
  maxW: "800px",
} as const;
